import type { CSSProperties, FC, ReactNode } from 'react'

import { BadgeCheck, ShieldCheck } from 'lucide-react'

import { cn } from '@/lib/utils'
import { TelegramGlyph } from '@/components/marketplace/telegram-glyph'

const ITEMS = [
    /*
        "Checked", not "Reviewed". Every listing really is checked against the
        platform's safety rules and its marketplace's own rules; a PERSON reads
        every listing only where the owner turned manual review on, so
        "Reviewed" promised something the platform cannot promise for all of them.
    */
    { icon: ShieldCheck, lines: ['Checked', 'Listings'] },
    { icon: BadgeCheck, lines: ['Verified', 'Sellers'] },
    { icon: TelegramGlyph, lines: ['Telegram', 'Powered'] }
]

interface TrustIndicatorsProps {
    className?: string
    style?: CSSProperties
}

/**
 * The three compact proof points under the calls to action. Outlined black
 * marks, two short uppercase lines each, no colour — the claim carries the
 * weight, not the styling.
 */
export const TrustIndicators: FC<TrustIndicatorsProps> = ({ className, style }): ReactNode => {
    return (
        <ul style={style} className={cn('flex flex-wrap items-center gap-x-6 gap-y-3', className)}>
            {ITEMS.map(({ icon: Icon, lines }) => (
                <li key={lines.join(' ')} className='flex items-center gap-2'>
                    <Icon className='size-5 shrink-0 text-ink-900' strokeWidth={1.75} aria-hidden='true' />

                    <span className='hero-label flex flex-col text-[12px] leading-[1.1] tracking-[0.01em] text-ink-900'>
                        <span>{lines[0]}</span>
                        <span>{lines[1]}</span>
                    </span>
                </li>
            ))}
        </ul>
    )
}
